import React, {forwardRef, useState} from "react";

import EventNotes from "../EventNotes";
import ChangeQuarterAndTime from "../ChangeQuarterAndTime";
import ChangeTeams from "../ChangeTeams";
import ChangeEventType from "../ChangeEventType";
import SelectChangePlayers from "../SelectChangePlayers";
import TypeOfEventType from "../TypeOfEventType";
import Header from "../Header";
import ConfirmButton from "../ConfirmButton";
import TypeOfCornerGoal from "../TypeOfCornerGoal";
import Submit from "./../HandleSubmit"

const handleSubmit = (options) => {
    const {matchData, matchId, setMatchData, eventDetailsToEdit} = options;
    const event = eventDetailsToEdit;
    const eventQuarter = event?.quarterSelected;
    let quarter = '';
    const player = event?.playerSelected?.id;
    const team = event?.sideSelected?.id;
    if(eventQuarter) {
        switch (eventQuarter) {
            case 'Q1':
                quarter = 1;
                break;
            case 'Q2':
                quarter = 2;
                break;
            case 'Q3':
                quarter = 3;
                break;
            case 'Q4':
                quarter = 4;
                break;
        }
    }
    const pcEvent = {
        minute: Math.ceil(event.timestamp/60),
        quarter,
        scorerContact: player,
        team,
        additionalData: event.eventNotes,
        isChanged: true
    }

    const update = {
        matchPosts: matchData.matchPosts.map(post => {
            if(event.id === post.id) {
                return {
                    ...post,
                    ...pcEvent,
                }
            }
            return post;
        })
    }
    Submit(matchId, matchData, update, setMatchData);
}

const EditCornerEvent = forwardRef(
  (
    {
      setIsEditModalOpen,
      sides,
      eventDetailsToEdit,
      setEventDetailsToEdit,
      EVENT_TYPES,
      PS_TYPES,
      setEventsToShow,
      setSides,
      goals,
      setGoals,
      isEditing,
      setIsEditing,
      PC_CORNERGOAL_TYPES,
      matchId,
      matchData,
      setMatchData,
    },
    ref
  ) => {
    const showDoneButton =
      eventDetailsToEdit?.typeOfEventTypeSelected &&
      eventDetailsToEdit?.type &&
      eventDetailsToEdit?.sideSelected &&
      eventDetailsToEdit?.sideNotSelected &&
      (eventDetailsToEdit?.typeOfCornerGoalSelected ||
        eventDetailsToEdit?.typeOfEventTypeSelected?.name === "Daneben");
    const [confirmButton, setConfirmButton] = useState(false);
    return (
      <div
        ref={ref}
        style={{
          backgroundColor: "#E5E5E5",
        }}
      >
        <Header
          eventDetails={eventDetailsToEdit}
          setEventDetails={setEventDetailsToEdit}
          setModalOpen={setIsEditModalOpen}
          isEditing={isEditing}
          setEventsToShow={setEventsToShow}
          matchData={matchData}
          matchId={matchId}
          setMatchData={setMatchData}
        />
        <ChangeQuarterAndTime
          eventDetails={eventDetailsToEdit}
          setEventDetails={setEventDetailsToEdit}
          matchId={matchId}
          setMatchData={setMatchData}
          matchData={matchData}
          setConfirmButton={setConfirmButton}
          setEventsToShow={setEventsToShow}
        />
        <ChangeTeams
          sides={sides}
          setSides={setSides}
          setGoals={setGoals}
          eventDetails={eventDetailsToEdit}
          setEventDetails={setEventDetailsToEdit}
        />
        <ChangeEventType
          EVENT_TYPES={EVENT_TYPES}
          eventDetails={eventDetailsToEdit}
          setEventDetails={setEventDetailsToEdit}
          preventChange={true}
        />

        <TypeOfEventType
          GOAL_TYPES={PS_TYPES}
          eventDetails={eventDetailsToEdit}
          setEventDetails={setEventDetailsToEdit}
        />
        {eventDetailsToEdit?.typeOfEventTypeSelected?.name !== "Daneben" && (
          <TypeOfCornerGoal
            GOAL_TYPES={PC_CORNERGOAL_TYPES}
            eventDetails={eventDetailsToEdit}
            setEventDetails={setEventDetailsToEdit}
            preventChange={true}
          />
        )}

          <SelectChangePlayers
            eventDetails={eventDetailsToEdit}
            setEventDetails={setEventDetailsToEdit}
          />

        <EventNotes
          textAreaValue={eventDetailsToEdit?.eventNotes}
          showConfirmCancelButtons={!!eventDetailsToEdit?.eventNotes?.length}
          confirmButtonAction={() => {}}
          cancelButtonAction={() => {
            setEventDetailsToEdit((data) => ({
              ...data,
              eventNotes: "",
            }));
          }}
          onChange={(e) => {
            setEventDetailsToEdit((data) => ({
              ...data,
              eventNotes: e.target.value,
            }));
          }}
        />

        {showDoneButton && (
          <ConfirmButton
            action={() => {
                handleSubmit({matchData, matchId, setMatchData, eventDetailsToEdit});
                setEventsToShow((data) => {
                return [
                  ...data?.map((item) => {
                    if (item?.id === eventDetailsToEdit?.id) {
                      return eventDetailsToEdit;
                    } else return item;
                  }),
                ];
              });
              setIsEditing(false);
              setIsEditModalOpen(false);
            }}
          />
        )}
      </div>
    );
  }
);

export default EditCornerEvent;
